var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111",
    transform: "translate(-1297 -85.221)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_152",
    "data-name": "Rectangle 152",
    className: "cls-1",
    width: 18,
    height: 2,
    transform: "translate(1297 85.221)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153",
    "data-name": "Rectangle 153",
    className: "cls-1",
    width: 12,
    height: 2,
    transform: "translate(1300 91.221)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154",
    "data-name": "Rectangle 154",
    className: "cls-1",
    width: 18,
    height: 2,
    transform: "translate(1297 97.221)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu);
export default __webpack_public_path__ + "static/media/Icon_Menu.c06bf299457476bf13f6a6b7c25ea793.svg";
export { ForwardRef as ReactComponent };